import React, {useState, useCallback} from 'react';
import {InputGroup, Input, Button} from 'reactstrap';
//import { getDataForCompanyAutocomplete } from 'utils/api';
import {isArray} from 'util';
//import testUrlList from './urlListForTesting';

let timeout;

export default function AddCompanyInput(props) {
    const {onSubmit, disabled, value, inputPlaceholder, handleManualSubmit,
        handleChange, handleFollowClick, followBtnSubmitting, loading} = props;
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [autocompleteData, setAutocompleteData] = useState(null);

    // useEffect(() => {
    //     let failCount1 = 0;
    //     let failCount2 = 0;
    //     console.log('start');
    //     console.log('--------------------------------------------------');
    //     testUrlList.forEach(url => {
    //         console.log('url: ', url);
    //         if(!isValidURL(url)) {
    //             console.log('FAILED - 1')
    //             failCount1++;
    //         }
    //     });
    //     console.log('isValidUrl fail count: ', failCount1);
    //     console.log('validURL fail count: ', failCount2);
    //     console.log('--------------------------------------------------');
    //     console.log('end');
    // }, [])

    // const searchChange = (e) => {
    //     if(!disabled){
    //         if (e.key === 'Enter' && !loading) {
    //             if(e.target.value.trim()){
    //                 onSubmit(value);
    //             }
    //         } else {
    //             handleChange(e.target.value);
    //         } 
    //     }
    // };

    const getAutocomplete = (name, isOpen) => {
        fetch('https://autocomplete.clearbit.com/v1/companies/suggest?query=' + name)
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if(data && isArray(data)) {
                    setAutocompleteData(data);
                    setIsAutocompleteOpen(isOpen);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    function debounce(func, wait) {
        return function(...args) {
            const context = this;
            if(timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
                func.apply(context, args);
            }, wait);
        };
    }

    const clearUpAndSubmit = (value, byUrl, autoCompleteObj) => {
        clearTimeout(timeout);
        setIsAutocompleteOpen(false);
        setAutocompleteData(null);
        onSubmit(value, byUrl, autoCompleteObj);
    };

    const debouncedAutocomplete = useCallback(debounce(getAutocomplete, 500), []);

    const handleInputChange = (e) => {
        if(!disabled) {
            if(e.key === 'Enter' && !loading) {
                if(e.target.value && e.target.value.trim()) {
                    handleManualSubmit(e.target.value.trim(), autocompleteData)
                    // clearUpAndSubmit(e.target.value.trim(), true);
                }
            } else {
                if(e.target.value && e.target.value.trim() !== '') {
                    let afterCropLink = e.target.value.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
                    if(afterCropLink.substring(0, 3) === 'www') {
                        //afterCropLink = afterCropLink.slice(4);
                        afterCropLink = afterCropLink.substring(afterCropLink.indexOf('.') + 1);
                    }
                    debouncedAutocomplete(afterCropLink, true);
                } else {
                    setIsAutocompleteOpen(false);
                    clearTimeout(timeout);
                }
                handleChange(e.target.value);
            }
        }
    };

    const isValidURL = (string) => {
        var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return (res !== null);
    };

    const changeInputToAutocomplete = (autoCompleteObj) => {
        // console.log(domainFromAutocomplete);
        // if((value.includes('https://') || value.includes('http://')) && isValidURL(value)) {
        //     console.log(value);
        //     handleChange(value);
        //     clearUpAndSubmit(value, true, autoCompleteObj);
        // } else {
        console.log(autoCompleteObj);
        handleChange(autoCompleteObj.domain);
        clearUpAndSubmit(autoCompleteObj.domain, true, autoCompleteObj);
        // }
    };

    const getPreviewWithoutUrl = () => {
        clearUpAndSubmit(value, false);
    };

    return (
        <div className="w-100 d-flex flex-column align-items-center">
            <InputGroup className="d-flex justify-content-between">
                <div className="addinput-plusicon">
                    <i className="fas fa-plus-circle"/>
                </div>
                <Input
                    onKeyPress={(e) => handleInputChange(e)}
                    onChange={(e) => handleInputChange(e)}
                    value={value}
                    placeholder={inputPlaceholder}
                    maxLength={64}
                    type="text"
                    className="companies-create-input"
                    style={isAutocompleteOpen ?
                        {
                            borderBottomLeftRadius: '0',
                            borderBottomRightRadius: '0',
                            borderTopLeftRadius: '0.25rem',
                            borderTopRightRadius: '0.25rem',
                        }
                        :
                        {borderRadius: '0.25rem'}
                    }
                    autoComplete="off"
                    disabled={disabled}
                />
                {!disabled && !loading && value.trim() && (
                    <i
                        onClick={() => {
                            handleChange('');
                            setIsAutocompleteOpen(false);
                            clearTimeout(timeout);
                        }}
                        className="fa fa-times-circle create-fetch_inputicon-cross"
                        style={{padding: '14.5px 5px', fontSize: '16px'}}
                    />
                )}
                {value.trim() && (
                    <React.Fragment>
                        {loading ? (
                            <div className="create-fetch_inputicon-glass"
                                 style={{display: 'flex', padding: '14.5px', fontSize: '16px'}}>
                                <i className="fa fa-spinner fa-spin"/>
                            </div>
                        ) : !disabled && (
                            <i
                                // onClick={() => {clearUpAndSubmit(value, true);}}
                                // onClick={() => handleFollowClick(item)}
                                onClick={() => handleManualSubmit(value, autocompleteData)}
                                className="fa fa-search create-fetch_inputicon-glass"
                                style={{padding: '14.5px 10px 14.5px 5px', fontSize: '16px'}}
                            />
                        )}
                    </React.Fragment>
                )}
            </InputGroup>
            {(!disabled && !loading) &&
            <div
                className="companies-autocomplete-container"
                style={isAutocompleteOpen ? {
                    border: '1px solid #e4e7ea',
                    height: `${autocompleteData.length * 40 + 40}px`,
                } : {height: '0'}}
            >
                {isAutocompleteOpen && autocompleteData &&
                <React.Fragment>
                    {autocompleteData.map(item =>
                        <div
                            className="companies-autocomplete-item d-flex justify-content-between"
                            key={item.name + item.domain}
                        >
                            <div
                                onClick={() => handleFollowClick(item)}
                                className="d-flex align-items-center flex-grow-1">
                                    <span style={{display: 'flex', justifyContent: 'center', paddingRight: '15px'}}>
                                        <img style={{width: '30px'}} src={item.logo} alt=""/>
                                    </span>
                                <span>{item.domain}</span>&nbsp;-&nbsp;<span
                                style={{fontWeight: '800'}}>{item.name}</span>
                            </div>
                            <Button
                                className="calltoaction-button d-flex align-items-center"
                                style={{height: '30px', width: '70.63px'}}
                                onClick={() => handleFollowClick(item)}
                            >
                                {/*{followBtnSubmitting ?*/}
                                {/*    <i className="fas fa-spinner fa-spin"/>*/}
                                    {/*:*/}
                                    Follow
                                {/*}*/}
                            </Button>
                        </div>,
                    )}
                    <div
                        onClick={() => getPreviewWithoutUrl()}
                        className="companies-autocomplete-item"
                        style={{borderTop: '1px solid #e4e7ea'}}
                    >
                                <span style={{color: '#FF8700', fontSize: '25px', paddingRight: '10px'}}>
                                    <i className="fas fa-plus-circle"/>
                                </span>
                        <span>Create custom entity "<span style={{fontWeight: '700'}}>{value}</span>"</span>
                    </div>
                </React.Fragment>
                }
            </div>
            }
        </div>
    );
}
